import { Injectable } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  static getErrorMsg(
    validatorName: string,
    validatorErrors?: ValidationErrors,
    fieldName?: string
  ) {
    fieldName = fieldName?.replace('_', ' ') || 'campo';
    const config = {
      required: `${ValidationService.capitalize(fieldName)} é obrigatório!`,
      pattern: `Esse ${fieldName.toLowerCase()} é inválido!`,
      minlength: `O ${fieldName.toLowerCase()} precisa ter no mínimo ${validatorErrors.requiredLength} dígitos!`,
      maxlength: `O ${fieldName.toLowerCase()} pode ter no máximo ${validatorErrors.requiredLength} dígitos!`,
      'Mask error': `Esse ${fieldName.toLowerCase()} é inválido!`,
    };
    return config[validatorName];
  }

  static capitalize(value: string): string {
    if (typeof value !== 'string') { return ''; }
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}
